import { CdkDrag, CdkDragDrop, CdkDragEnter, CdkDropList, CdkDropListGroup, DragDropModule, DragRef, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { sectionDiplaySetting } from '../../../models/contact.model';
import { eFeatures, eSection, eUserRole } from '../../../models/enum.model';
import { SimpleResponse } from '../../../models/genericResponse.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { SAMMemFieldsResponse, SamMenDisplaySettingResponse } from '../../../models/sammem-field.model';
import { ContactService } from '../../../services/contact.service';
import { GlobalService } from '../../../services/global.service';
import { NotificationService } from '../../../services/notification.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
declare var $: any;

@Component({
    selector: 'app-sam-mem-configuration',
    templateUrl: './sam-mem-configuration.component.html',
    styleUrl: './sam-mem-configuration.component.css',
})
export class SamMemConfigurationComponent {
    user: CLPUser;
    eUserRole = eUserRole;
    eventUpdateCounter = 0;
    isInit: boolean = false;
    isChange: boolean = false;
    showSpinner: boolean = false;
    encryptedUser: string;
    userResponse: UserResponse;
    roleFeaturePermissions: RoleFeaturePermissions;
    samMEMFieldResponse: SAMMemFieldsResponse;
    arrAllControls: any[] = [];
    arrSortedBySection: any[] = [];
    arrGenCtrl: any[] = [];
    @Input() isCommon: boolean = true;
    @Output() refreshEventSamMemList = new EventEmitter<boolean>(false);
    newSection: any;
    oldSection: any;
    newIndex: any;
    oldIndex: any;
    checkValeForSelectedItem: any;
    checkValueForSelectedInput: string;
    @ViewChild(CdkDropList) placeholder: CdkDropList;
    private target: CdkDropList = null;
    private targetIndex: number;
    private source: CdkDropList = null;
    private sourceIndex: number;
    private dragRef: DragRef = null;
    boxWidth = '200px';
    boxHeight = '200px';

    constructor(public notifyService: NotificationService, private fb: FormBuilder, public _contactService: ContactService,
        private _utilityService: UtilityService,
        public _localService: LocalService,
        private _route: ActivatedRoute,
        public _globalService: GlobalService,
        private _router: Router) {
        this._localService.isMenu = true;
    }

    ngOnInit() {
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        this.showSpinner = true;
                        this.loadData();

                    }
                    else
                        this._router.navigate(['/login']);
                })
            }
            else
                this._router.navigate(['/login']);
        });
    }

    public eventOptions = {
        onUpdate: () => this.eventUpdateCounter++,
        draggable: '.draggable',
        group: 'shared',
        filter: 'input',
        preventOnFilter: false,
        onStart: (/**Event*/evt) => {
            this.startEe(evt);

        },
        onEnd: (/**Event*/evt) => {
            this.endEv(evt);
        }
    };

    public eventOptionsSection = {
        onUpdate: () => this.eventUpdateCounter++,
        draggable: '.draggable',
    };

    async loadData() {
        await this.getSamMemFieldsConfiguration();
    }

    ngAfterViewChecked() {
        if (this.isInit) {
            this.isInit = false;
            this.loadConfiguration();
        }
        if (this.isChange) {
            this.isChange = false;
            this.updateConfiguration();
        }
    }




    loadConfiguration() {
        for (var i = 0; i < this.arrGenCtrl.length; i++) {
            if (this.arrGenCtrl[i].inputConfigFiled == 'radio' || this.arrGenCtrl[i].inputConfigFiled == 'toggle' || this.arrGenCtrl[i].inputConfigFiled == 'toggleHide') {
                var radioGen_id = "radioGen" + i;
                $('input:radio[name=' + radioGen_id + '][value=' + this.arrGenCtrl[i].isShow + ']').attr('checked', true);
            }
            else {
                var cbGen_id = "cbGen" + i;
                $("#" + cbGen_id).prop("checked", this.arrGenCtrl[i].isShow == 1 ? true : false);
                $("#spanGen" + i).text(this.arrGenCtrl[i].isShow == 1 ? "Show Mandatory" : "Show");
            }
        }
    }

    updateConfiguration() {
        for (var i = 0; i < this.arrGenCtrl.length; i++) {
            if (this.arrGenCtrl[i].inputConfigFiled == 'radio' || this.arrGenCtrl[i].inputConfigFiled == 'toggle' || this.arrGenCtrl[i].inputConfigFiled == 'toggleHide') {
                var radioGen_id = "radioGen" + i;
                $('input:radio[name=' + radioGen_id + '][value=' + this.arrGenCtrl[i].isShow + ']').prop('checked', true);
            }
            else {
                var cbGen_id = "cbGen" + i;
                $("#" + cbGen_id).prop("checked", this.arrGenCtrl[i].isShow == 1 ? true : false);
                $("#spanGen" + i).text(this.arrGenCtrl[i].isShow == 1 ? "Show Mandatory" : "Show");
            }
        }
    }

    async getSamMemFieldsConfiguration() {
        await this._contactService.sAMMEMContactFields_Get_Configuration(this.encryptedUser, this.user.cLPCompanyID, this.user.cLPUserID, true)
            .then(async (result: SAMMemFieldsResponse) => {
                this.samMEMFieldResponse = UtilityService.clone(result);
                console.log(this.samMEMFieldResponse, "this is raw response ");
                this.arrAllControls = [];
                var keys = Object.keys(this.samMEMFieldResponse.memFields).filter(i => i.indexOf("displaySetting") == -1);
                ////for (var i = 0; i < keys.length; i++) {
                ////    if (this.contactFieldsResponse.sAMContactFields[keys[i]])
                ////        this.arrAllControls.push(this.contactFieldsResponse.sAMContactFields[keys[i]]);
                ////}
                keys.forEach((item) => {
                    if (this.samMEMFieldResponse.memFields[item])
                        this.arrAllControls.push(this.samMEMFieldResponse.memFields[item]);
                });
                ////console.log('this.arrAllControls', this.arrAllControls);
                //if (this.contactFieldsResponse.sAMContactFields.sAMContactMoreFields) {
                //    var keys_moreFields = Object.keys(this.contactFieldsResponse.sAMContactFields.sAMContactMoreFields);
                //    for (var i = 0; i < keys_moreFields.length; i++) {
                //        if (!isNullOrUndefined(this.contactFieldsResponse.sAMContactFields.sAMContactMoreFields[keys_moreFields[i]]))
                //            this.arrAllControls.push(this.contactFieldsResponse.sAMContactFields.sAMContactMoreFields[keys_moreFields[i]]);
                //    }
                //}


                this.arrGenCtrl = this.arrAllControls.filter(i => i.section == eSection.General);
                //this.arrCommunicationCtrl = this.arrAllControls.filter(i => i.section == eSection.Communication);
                //this.arrAddressCtrl = this.arrAllControls.filter(i => i.section == eSection.Address);
                //this.arrClassificationCbCtrl = this.arrAllControls.filter(i => i.section == eSection.ClassificationCheckBox);
                //this.arrClassificationDropDownCtrl = this.arrAllControls.filter(i => i.section == eSection.ClassificationDropDown);
                //this.arrAddtionalInformationCtrl = this.arrAllControls.filter(i => i.section == eSection.AddtionalInformation);
                //this.arrImportantDatesCtrl = this.arrAllControls.filter(i => i.section == eSection.ImportantDates);
                //this.arrMoreFieldsCtrl = this.arrAllControls.filter(i => i.section == eSection.MoreFields);
                //this.arrCommentsCtrl = this.arrAllControls.filter(i => i.section == eSection.Comments);
                //this.arrSysCtrl = this.arrAllControls.filter(i => i.section == eSection.System && i.inputConfigFiled != null);


                this.arrGenCtrl.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1);
                //this.arrCommunicationCtrl.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1);
                //this.arrAddressCtrl.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1);
                //this.arrClassificationCbCtrl.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1);
                //this.arrClassificationDropDownCtrl.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1);
                //this.arrAddtionalInformationCtrl.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1);
                //this.arrImportantDatesCtrl.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1);
                //this.arrMoreFieldsCtrl.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1);
                //this.arrCommentsCtrl.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1);
                //this.arrSysCtrl.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1);

                //let finalElement = this.arrAddtionalInformationCtrl.length - this.companyData?.contactMaxTXT;
                //this.arrAddtionalInformationCtrl.splice(-finalElement, finalElement);

                if (!isNullOrUndefined(this.samMEMFieldResponse.memFields) && !isNullOrUndefined(this.samMEMFieldResponse.memFields) /*&& !isNullOrUndefined(this.contactFieldsResponse.sAMContactFields.displaySetting.fieldDiplaySettings.length > 0)*/) {
                    this.arrSortedBySection = [];
                    let sectionDiplaySettings: sectionDiplaySetting[] = this.samMEMFieldResponse.memFields.displaySetting.sectionDiplaySettings;
                    sectionDiplaySettings.sort((a, b) => (a.sectionDisplayOrder > b.sectionDisplayOrder) ? 1 : -1);
                    for (var i = 0; i < sectionDiplaySettings.length; i++) {
                        switch (eSection[sectionDiplaySettings[i].sectionId]) {
                            case eSection[eSection.General]: this.arrSortedBySection.push({ sectionName: 'General', sectionId: sectionDiplaySettings[i].sectionId, items: this.arrGenCtrl }); break;
                            //        case eSection[eSection.Address]: this.arrSortedBySection.push({ sectionName: 'Address', sectionId: sectionDiplaySettings[i].sectionId, items: this.arrAddressCtrl }); break;
                            //        case eSection[eSection.AddtionalInformation]: this.arrSortedBySection.push({ sectionName: 'Additional Information Custom Text Fields', sectionId: sectionDiplaySettings[i].sectionId, items: this.arrAddtionalInformationCtrl }); break;
                            //        case eSection[eSection.ClassificationDropDown]: this.arrSortedBySection.push({ sectionName: 'Classification Drop Down Custom Fields', sectionId: sectionDiplaySettings[i].sectionId, items: this.arrClassificationDropDownCtrl }); break;
                            //        case eSection[eSection.ClassificationCheckBox]: this.arrSortedBySection.push({ sectionName: 'Classification Checkbox Custom Fields', sectionId: sectionDiplaySettings[i].sectionId, items: this.arrClassificationCbCtrl }); break;
                            //        case eSection[eSection.Comments]: this.arrSortedBySection.push({ sectionName: 'Comments', sectionId: sectionDiplaySettings[i].sectionId, items: this.arrCommentsCtrl }); break;
                            //        case eSection[eSection.ImportantDates]: this.arrSortedBySection.push({ sectionName: 'Important Dates (Default Titles)', sectionId: sectionDiplaySettings[i].sectionId, items: this.arrImportantDatesCtrl }); break;
                            //        case eSection[eSection.MoreFields]: this.arrSortedBySection.push({ sectionName: 'More Fields (Default Titles)', sectionId: sectionDiplaySettings[i].sectionId, items: this.arrMoreFieldsCtrl }); break;
                            //        case eSection[eSection.General]: this.arrSortedBySection.push({ sectionName: 'General', sectionId: sectionDiplaySettings[i].sectionId, items: this.arrGenCtrl }); break;
                            //        case eSection[eSection.System]: this.arrSortedBySection.push({ sectionName: 'System', sectionId: sectionDiplaySettings[i].sectionId, items: this.arrSysCtrl }); break;
                        }
                    }
                    this.isInit = true;
                    
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("configuration.getSamMemFieldsConfiguration", err.message, null, 'cLPCompanyID ' + this.user.cLPCompanyID + 'cLPUserID ' + this.user.cLPUserID);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }


    private async authenticateR() {
        this.showSpinner = true;
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.ContactModuleSettings)
            .then(async (result: UserResponse) => {
                if (!isNullOrUndefined(result)) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (!isNullOrUndefined(this.userResponse)) {
                        if (!isNullOrUndefined(this.userResponse?.user)) {
                            this.user = this.userResponse.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("configuration.authenticateR", err.message, null, 'Features ' + eFeatures.ContactModuleSettings);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }



    async onreset() {
        await this.getSamMemFieldsConfiguration();
        /* this.loadConfiguration();*/
        this.notifyService.showSuccess("No changes were made.", "", 3000);
    }


    async resetSAMMemConfiguration() {
        this.showSpinner = true;
        await this._contactService.SAMMemFields_Reset_Configuration(this.encryptedUser, this.user.cLPCompanyID, this.user.cLPUserID).then(response => {
            if (response && response.messageBool) {
                this.getSamMemFieldsConfiguration();
            }
            this.showSpinner = false;
        }, _err => {
            if (_err) {
                this.showSpinner = false;
                this._globalService.error("configuration.resetSAMConfiguration", _err, null, 'cLPCompanyID ' + this.user.cLPCompanyID + 'cLPUserID ' + this.user.cLPUserID);
            }
        });
        this.showSpinner = false;
    }


    async saveSAMmemConfiguration() {
        this.showSpinner = true;

        let _displaySettingResponse: SamMenDisplaySettingResponse = { samcontactFields: [], displaySetting: { fieldDiplaySettings: [], sectionDiplaySettings: [] } };

        for (var i = 0; i < this.arrSortedBySection.length; i++) {
            let _setionDiplaySetting: sectionDiplaySetting = { sectionId: this.arrSortedBySection[i].sectionId, sectionName: this.arrSortedBySection[i].sectionName, sectionDisplayOrder: i }
            _displaySettingResponse.displaySetting.sectionDiplaySettings.push(_setionDiplaySetting);
        }

        if (!isNullOrUndefined(this.samMEMFieldResponse) && !isNullOrUndefined(this.samMEMFieldResponse.memFields)) {
            var contactFields = this.samMEMFieldResponse.memFields;

            var arrFinal = [];

            let arrGeneral: any = (this.arrSortedBySection.filter(i => i.sectionId == eSection.General)[0]).items;

            if (!isNullOrUndefined(arrGeneral) && arrGeneral.length > 0) {
                for (var i = 0; i < arrGeneral.length; i++) {
                    arrGeneral[i].section = eSection.General;
                    arrGeneral[i].displayOrder = (i + 1);
                    arrGeneral[i].fieldTitle = $("#tbGenTitle" + i).val();

                    if (arrGeneral[i].inputConfigFiled == 'radio' || arrGeneral[i].inputConfigFiled == 'toggle' || arrGeneral[i].inputConfigFiled == 'toggleHide') {
                        var radioGen_id = "radioGen" + i;
                        arrGeneral[i].isShow = $('input[name=' + radioGen_id + ']:checked').val();
                        arrGeneral[i].isShow = +arrGeneral[i].isShow;
                    }
                    else {
                        var cbGen_id = "cbGen" + i;
                        arrGeneral[i].isShow = $('#' + cbGen_id).is(":checked") ? 1 : 0;
                    }
                    arrFinal.push(arrGeneral[i]);
                }
            }

            if (arrFinal && arrFinal.length) {
                arrFinal.forEach(item => {
                    if (isNaN(item.isShow) || item.isShow == null || item.isShow == undefined)
                        item.isShow = 0;
                });
            }
            _displaySettingResponse.samcontactFields = arrFinal;

            await this._contactService.sAMMEMContactFields_Update_Configuration(this.encryptedUser, _displaySettingResponse, this.user.cLPCompanyID)
                .then(async (result: SimpleResponse) => {
                    if (!isNullOrUndefined(result)) {
                        var res = UtilityService.clone(result);
                        this.showSpinner = false;
                        this.refreshEventSamMemList.emit(true);
                        this.notifyService.showSuccess("SAM Member Configuration updated successfully", "", 3000);
                    }
                    else
                        this.showSpinner = false;
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false;
                    this._globalService.error("sam-Configuration.saveSAMConfiguration", err.message, _displaySettingResponse, 'cLPCompanyID ' + this.user.cLPCompanyID);
                    this._utilityService.handleErrorResponse(err);
                    this.notifyService.showError("some error occurred, Please contact Administrator.", "", 3000);
                });
            this.showSpinner = false;
        }
        this.getSamMemFieldsConfiguration();

    }

    handleChange(evt) {
        this.newSection = evt.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.firstElementChild.getElementsByTagName('h5')[0]?.innerText;
        var id = evt.currentTarget.name
        this.newIndex = Number(id[id.length - 1]);
        if (this.newIndex != undefined && this.newSection) {
            this.checkValeForSelectedItem = Number(evt.currentTarget.value);
            this.updateArray();
        }
    }

    cancel() {
        this.getSamMemFieldsConfiguration();
    }


    updateArray() {
        if (this.newSection == "General") {
            if (!isNullOrUndefined(this.checkValeForSelectedItem))
                this.arrGenCtrl[this.newIndex].isShow = this.checkValeForSelectedItem;
            else
                this.arrGenCtrl[this.newIndex].isShow = this.arrGenCtrl[this.newIndex].isShow;
            this.arrGenCtrl[this.newIndex].fieldTitle = this.checkValueForSelectedInput ? this.checkValueForSelectedInput : this.arrGenCtrl[this.newIndex].fieldTitle;

        }
        this.checkValueForSelectedInput = undefined;
    }

    startEe(evt) {
        const target = evt.originalEvent.target as HTMLElement;
        if (target.tagName === 'INPUT') {
            event.preventDefault();
            return;
        }
        var sectionSelFrom = evt.item?.offsetParent.firstElementChild.getElementsByTagName('h5')[0]?.innerText;
        this.oldSection = sectionSelFrom;
        if (evt.item.getElementsByTagName('input').item(0).type == "checkbox")
            this.checkValeForSelectedItem = evt.item?.getElementsByTagName('input').item(0).checked;
        else {
            if (evt.item.getElementsByTagName('input').item(0).type == "text")
                this.checkValueForSelectedInput = evt.item.getElementsByTagName('input').item(0).value;

            if (evt.item.getElementsByTagName('input')[1]) {
                var selectedRadioId = evt.item.getElementsByTagName('input')[1].name;
                var selectedRadioValue = $('input[name=' + selectedRadioId + ']:checked').val();
                this.checkValeForSelectedItem = Number(selectedRadioValue);
            }
        }
    }

    endEv(evt) {
        this.newSection = evt.item.offsetParent.firstElementChild.getElementsByTagName('h5')[0]?.innerText;
        this.newIndex = evt.newIndex;
        this.isChange = true;
        this.updateArray();
    }


    get connectedSectionIds(): string[] {
        return this.arrSortedBySection.map(s => s.sectionId.toString());
    }

    dropSectionItems(event: CdkDragDrop<any[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex
            );
        }

    }

    trackById(index: number, item: any) {
        return item.sectionId; 
    }

    ngAfterViewInit() {
        const placeholderElement = this.placeholder.element.nativeElement;

        placeholderElement.style.display = 'none';
        placeholderElement.parentNode.removeChild(placeholderElement);
    }


    onDropListDropped() {
        if (!this.target) {
            return;
        }

        const placeholderElement: HTMLElement =
            this.placeholder.element.nativeElement;
        const placeholderParentElement: HTMLElement =
            placeholderElement.parentElement;

        placeholderElement.style.display = 'none';

        placeholderParentElement.removeChild(placeholderElement);
        placeholderParentElement.appendChild(placeholderElement);
        placeholderParentElement.insertBefore(
            this.source.element.nativeElement,
            placeholderParentElement.children[this.sourceIndex]
        );

        if (this.placeholder._dropListRef.isDragging()) {
            this.placeholder._dropListRef.exit(this.dragRef);
        }

        this.target = null;
        this.source = null;
        this.dragRef = null;

        if (this.sourceIndex !== this.targetIndex) {
            moveItemInArray(this.arrSortedBySection[0]?.items, this.sourceIndex, this.targetIndex);
        }
    }

    onDropListEntered({ item, container }: CdkDragEnter) {
        if (container == this.placeholder) {
            return;
        }

        const placeholderElement: HTMLElement =
            this.placeholder.element.nativeElement;
        const sourceElement: HTMLElement = item.dropContainer.element.nativeElement;
        const dropElement: HTMLElement = container.element.nativeElement;
        const dragIndex: number = Array.prototype.indexOf.call(
            dropElement.parentElement.children,
            this.source ? placeholderElement : sourceElement
        );
        const dropIndex: number = Array.prototype.indexOf.call(
            dropElement.parentElement.children,
            dropElement
        );

        if (!this.source) {
            this.sourceIndex = dragIndex;
            this.source = item.dropContainer;

            placeholderElement.style.width = this.boxWidth + 'px';
            placeholderElement.style.height = this.boxHeight + 40 + 'px';

            sourceElement.parentElement.removeChild(sourceElement);
        }

        this.targetIndex = dropIndex;
        this.target = container;
        this.dragRef = item._dragRef;

        placeholderElement.style.display = '';

        dropElement.parentElement.insertBefore(
            placeholderElement,
            dropIndex > dragIndex ? dropElement.nextSibling : dropElement
        );

        this.placeholder._dropListRef.enter(
            item._dragRef,
            item.element.nativeElement.offsetLeft,
            item.element.nativeElement.offsetTop
        );
    }

}
